import { RefundRequestHisto } from "./request-refund-histo.model";

export class RefundRequest{
    constructor(

        public idReembolsoSolicitud?: number, //idRequestRefund
        public usuario?: string, //idUser
        public contrato?: string, //contractNumber
        public tipoContrato?: string, //typeContract
        public idPlan?: string, //idTypePlan
        public tipoPlan?: string, //typePlan
        public idTipoDocumento?: string, //idTypeDocumentId
        public idDocumento?: string, //idDocumentId
        public nombreCliente?: string, //clientName
        public email?: string, //email
        public telefonoFijo?: string, //phoneHome
        public telefonoCelular?: string, //phoneMobile
        public autorizoEmail?: string, //checkSendMail
        public reembolsoSolicitudHisto?: RefundRequestHisto //requestHistoItem
    ){}    
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/request-refund.model.ts